"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePublicHoliday = exports.addPublicHoliday = exports.addPublicHolidays = exports.deletePublicHoliday = exports.getPublicHoliday = exports.getPublicHolidaysByCountryAndRegion = exports.getPublicHolidays = exports.getAllPublicHolidays = void 0;
const _ = require("lodash");
const getAllPublicHolidays = async (supabase) => {
    // get a date 2 years in the future
    const date = new Date();
    date.setFullYear(date.getFullYear() + 2);
    // convert date top YYYY-MM-DD
    const dateStr = date.toISOString().split("T")[0];
    const startDate = new Date().toISOString().split("T")[0];
    const { data: locations, error } = await supabase
        .from("public_holidays")
        .select(`*,
      country:country_id(regions!inner(id, name), id, name),
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .lt("start_date", dateStr)
        .gt("start_date", startDate)
        .order("start_date", { ascending: true });
    if (!error)
        return locations;
    return error;
};
exports.getAllPublicHolidays = getAllPublicHolidays;
const getPublicHolidays = async (supabase, country_id) => {
    const { data: locations, error } = await supabase
        .from("public_holidays")
        .select(`*,
      country:country_id(regions!inner(id, name), id, name),
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("country_id", country_id)
        .order("start_date", { ascending: true });
    if (!error)
        return locations;
    return error;
};
exports.getPublicHolidays = getPublicHolidays;
const getPublicHolidaysByCountryAndRegion = async (supabase, country_id, region_id) => {
    const { data: locations, error } = await supabase
        .from("public_holidays")
        .select(`*,
      country:country_id(regions!inner(id, name), id, name),
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("country_id", country_id)
        .contains("regions", [region_id])
        .order("start_date", { ascending: true });
    if (!error)
        return locations;
    return error;
};
exports.getPublicHolidaysByCountryAndRegion = getPublicHolidaysByCountryAndRegion;
const getPublicHoliday = async (supabase, id) => {
    const { data: location, error } = await supabase
        .from("public_holidays")
        .select(`*,
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return location;
    return error;
};
exports.getPublicHoliday = getPublicHoliday;
const deletePublicHoliday = async (supabase, id) => {
    const { data, error } = await supabase
        .from("public_holidays")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deletePublicHoliday = deletePublicHoliday;
const addPublicHolidays = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.forEach((o) => {
            o.modified_by = user?.id;
            o.created_by = user?.id;
        });
    }
    const { data, error } = await supabase
        .from("public_holidays")
        .insert(obj)
        .select();
    if (!error)
        return data;
    return error;
};
exports.addPublicHolidays = addPublicHolidays;
const addPublicHoliday = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase
        .from("public_holidays")
        .insert([obj])
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.addPublicHoliday = addPublicHoliday;
const updatePublicHoliday = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    delete updateObj.country;
    const { data, error } = await supabase
        .from("public_holidays")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updatePublicHoliday = updatePublicHoliday;
